// extracted by mini-css-extract-plugin
module.exports = {"unStart":"ShopExposure_style_unStart__3PybR","topTxt":"ShopExposure_style_topTxt__2k85f","undoneNum":"ShopExposure_style_undoneNum__1JiLX","desc":"ShopExposure_style_desc__3p17R"};